itsoftApp.createModule("checkMenuLink", function () {
    const module = this;
    const CheckMenuLink = function () {
        this.menuLinkElements = document.querySelectorAll(".l-header .btn, .l-footer .btn");
        this.menuItem = "";

        this.init();
    };
    CheckMenuLink.prototype.init = function () {
        const CHECK_MENU_LINK = this;
        Array.prototype.forEach.call(this.menuLinkElements, function (el) {
            /* находим все пустые ссылки, кроме тех, где нет решётки, и удаляем атрибут href, чтобы акцентирвать внимание на том, что мы находимся на текущей странице */
            /* применятся соответствующие стили, например, дял пункта меню, которая ссылается на текущую страницу */

            /* Нужно доработать на тот случай, если location.pathname == "/", a el.href!="/" */
            if (el.pathname === location.pathname && el.href !== "#" && ((el.hash === "" && !el.href.includes("#")) || (el.hash !== "" && el.getAttribute("href").includes("/")))) {
                // CHECK_MENU_LINK.menuItem = el.parentNode;
                el.classList.add("is-current");
                el.removeAttribute("href");
            }
        });
    };

    new CheckMenuLink();
    module.callback = CheckMenuLink;
});
